

import React, { useContext, useState } from 'react'
import { GlobalContext } from '../GlobalContext'
import CloudformationOutputs from '../CloudformationOutputs.json'
import Modal from '../ui-elements/Modal'
import RedAlert from '../ui-elements/RedAlert'

type Props = {
  questionAnswer: any
  isTemperature?: boolean
  size?: 'normal' | 'big'
  question?: any
}

function FormatQuestionAnswer({
  questionAnswer,
  isTemperature = false,
  size = 'normal',
  question
}: Props) {

  const {
    tableData,
    currentOrganisation
  } = useContext(GlobalContext)

  const [showPhotoModal, setShowPhotoModal] = useState(false)

  const classString = `
  ${size === 'normal' ? ' text-sm ' : ''}
  ${size === 'big' ? ' text-xl font-righteous text-brandblue ' : ''}
  `

  let unit = ''
  if (question && question.MeasurementUnit) {
    unit = ` ${question.MeasurementUnit}`
  } else if (isTemperature) {
    unit = ' °C'
  }

  function isValidIsoDateTime(str: string) {
    const regex = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/
    const match = str.match(regex)
    if (!match) return false
    const [_, year, month, day, hour, minute] = match.map(Number)
    const date = new Date(year, month - 1, day, hour, minute)
    return (
      date.getFullYear() === year &&
      date.getMonth() === month - 1 &&
      date.getDate() === day &&
      date.getHours() === hour &&
      date.getMinutes() === minute
    )
  }

  if (
    !questionAnswer
    || !questionAnswer.Answer
    || JSON.stringify(questionAnswer.Answer) === '{}'
    || JSON.stringify(questionAnswer.Answer) === '{"NULL":true}'
  ) return null
  // return <RedAlert>No value</RedAlert>


  return <span className={classString}>


    {questionAnswer.Answer instanceof Array &&
      <>{questionAnswer.Answer.map((option: string, index: number) => {
        return `${option}${index + 1 < questionAnswer.Answer.length ? ', ' : ''}`
      })}</>}


    {questionAnswer.Answer instanceof Object && !(questionAnswer.Answer instanceof Array) &&
      <>{Object.keys(questionAnswer.Answer).map((keyName: string, index: number) => {
        return `${keyName}: ${questionAnswer.Answer[keyName] || ''}${index + 1 < Object.keys(questionAnswer.Answer).length ? ', ' : ''}`
      })}</>}

    {typeof questionAnswer.Answer === 'number' ? <>{questionAnswer.Answer}{unit}</> : ''}

    {typeof questionAnswer.Answer === 'string' ? <>

      {isValidIsoDateTime(questionAnswer.Answer) ?
        `${questionAnswer.Answer.replace('T', ' ')}` :
        `${questionAnswer.Answer}${unit}`}

    </> : ''}

  </span>
}

export default FormatQuestionAnswer